// extracted by mini-css-extract-plugin
export default {"Tag":"styles_Tag__v8Pkb","removeIcon":"styles_removeIcon__j3UWs"};